import styled from 'styled-components'

import { colors } from 'styles/colors'

export const Container = styled.div`
    margin-top: 40px;

    background: #fff;
    box-shadow: 0px 5px 16px 0px #4949491f;
    border-radius: 16px;

    width: 100%;

    display: flex;

    @media (max-width: 1200px) {
        flex-direction: column;
    }
`

export const Content = styled.div`
    display: flex;

    @media (max-width: 1200px) {
        flex-direction: column;
    }
`

export const DivImage = styled.div`
    min-width: 150px;
    height: 100%;

    background: linear-gradient(
        to right,
        ${(p) => p.$gradientColor} 70%,
        white 30%
    );
    border-radius: 16px;

    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 40px 0;

    img {
        display: block;
        margin: 0 auto;
        width: 100px;
    }

    @media (max-width: 1200px) {
        background: linear-gradient(
            to bottom,
            ${(p) => p.$gradientColor} 70%,
            white 30%
        );
        padding: 40px 0 0;
    }
`

export const Info = styled.div`
    padding: 40px 0;

    font-style: normal;
    color: #282828;

    display: flex;
    flex-direction: column;

    > * + * {
        margin-top: 20px;
    }

    @media (max-width: 1200px) {
        margin: 30px;
        padding: 0;
        text-align: center;
    }
`

export const Title = styled.h1`
    font-weight: 300;
    font-size: 28px;
    line-height: 34px;
    text-transform: uppercase;
    color: ${(p) => p.$color};
`

export const Subtitle = styled.h2`
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 140%;
    text-transform: uppercase;
    color: ${(p) => p.$color};
`

export const Text = styled.p`
    font-weight: 300;
    font-size: 14px;
    line-height: 150%;
    color: #282828;
`

export const Link = styled.a`
    font-size: 12px;
    color: ${colors.defaultGreen};
    text-transform: uppercase;
    line-height: 14px;
`

export const ModalWrap = styled.div`
    .modal {
        align-items: center !important;
    }
`
